import Link from "./index";

import powerStations from "../../data/powerStations";
import alternatorChargers from "../../data/alternatorChargers";

const ProductLink = ({ brand, model, children, ...props }) => {
  const brandPowerStations = powerStations[brand]?.powerStations || {};

  // Try power-station lookup first
  let product = brandPowerStations[model];

  // If not found, check alternator chargers (slower as its an array)
  if (!product) {
    product = (alternatorChargers[brand] || []).find((p) => p.name === model); //TODO: Convert base data file to map to improve lookup
  }

  //TODO: Check batteries and other products

  // Fallback
  if (!product || !product.link) {
    return <span {...props}>{model}</span>;
  }

  // Prefer product.link, fallback to product.amazon
  const linkData = product.link || product.amazon || {};
  const { href, affiliateData, affiliate } = linkData;

  return (
    <Link
      href={href}
      affiliate={affiliate}
      affiliateData={affiliateData}
      {...props}
    >
      {children ? children : model}
    </Link>
  );
};

export default ProductLink;
